import React from 'react';
import MobilePage from '../UiComponents/MobilePage';

const qnaList = [
  {
    q: '동화 제작 신청은 어떻게 하나요?',
    a: '아주 간단해요.\n간편 로그인으로 가입한 뒤, 아이의 **이름**, **태어난 해**, 그리고 **사진**만 등록해 주세요.\n\n그다음 **\'이야기 생성하기\'**를 체크하면 준비 완료!\n이제 AI가 열일하면서, 우리 아이가 주인공인 동화를 차근차근 만들어갑니다.',
    askIcon: 'baby01.png',
    answerIcon: 'dad05.png',
  },
  {
    q: '도대체 동화는 언제 만들어지나요?',
    a: '솔직히 말씀드리면, **조금 기다려주셔야 할 때가 있어요.**\n텔링파파는 여러 아이들의 동화를 AI가 순서대로 만들고 있어서, 바로 뚝딱 완성되지는 않을 수 있거든요.\n\nAI는 지금도 열심히 일하고 있는 중입니다.\n더 빠르게 동화를 만들어드릴 수 있도록 계속 열심히 개선하고 있어요.',
    askIcon: 'mom01.png',
    answerIcon: 'dad01.png',
  },
  {
    q: '동화 내용이나 그림이 뭔가 좀 이상해요.',
    a: '가끔은 AI가 너무 오버 할 때가 있어요.\n그래서 문장이 조금 어색하거나, 그림이 살짝 엉뚱하게 나올 수 있습니다.\n이럴 땐 **동화 수정 요청**을 해주시면 됩니다.\n또 동화 페이지 오른쪽 아래의 **연필 아이콘**을 누르면, 내용을 직접 수정하거나 저희에게 수정 요청을 보낼 수 있어요.',
    askIcon: 'mom02.png',
    answerIcon: 'dad02.png',
  },
  {
    q: '\'이야기 생성하기\'를 체크했는데, 왜 체크가 풀려 있나요?',
    a: '이건 오류라기보다, 텔링파파가 잠깐 숨 고르는 중이라고 생각해 주세요.\n동화를 더 원활하게 만들기 위해, 일부 경우에는 **\'이야기 생성하기\'** 체크가 자동으로 해제되며 제작이 잠시 멈출 수 있어요.\n\n주로 이런 경우예요.\n\n- 아이 정보가 정확하지 않은 경우\n  (예: 이름에 오타가 있거나, AI가 알아보기 어려운 사진이 등록된 경우)\n- 오랫동안 텔링파파를 이용하지 않은 경우\n\n다시 동화를 만들고 싶다면?\n언제든 **\'이야기 생성하기\'**를 다시 체크해 주세요.\n그러면 동화 제작이 다시 시작됩니다.',
    askIcon: 'mom04.png',
    answerIcon: 'dad04.png',
  },
]

const renderText = (text) => {
  return text.split('\n').map((line, i) => {
    const parts = line.split(/(\*\*[^*]+\*\*)/g)
    return (
      <span key={i}>
        {parts.map((part, j) => {
          if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={j}>{part.slice(2, -2)}</strong>
          }
          return part
        })}
        {i < text.split('\n').length - 1 && <br />}
      </span>
    )
  })
}

const QnAItem = ({ q, a, askIcon, answerIcon }) => {
  return (
    <div className='mb-4'>
      <div className='flex items-start gap-3 bg-orange-50 rounded-xl px-3 py-3'>
        <img className='h-8 rounded-full flex-shrink-0 mt-0.5' src={`/image/qna/${askIcon}`} />
        <div className='flex-1 text-sm font-bold text-gray-700 mt-1'>{q}</div>
      </div>
      <div className='flex items-start gap-3 bg-blue-50 rounded-xl px-3 py-3 mt-2'>
        <img className='h-8 rounded-full flex-shrink-0 mt-0.5' src={`/image/qna/${answerIcon}`} />
        <div className='flex-1 text-sm text-gray-600 leading-6'>{renderText(a)}</div>
      </div>
    </div>
  )
}

const QnA = () => {
  return (
    <MobilePage>
      <div className='px-4 pb-12'>
        <div className='text-xl font-bold mt-6 mb-6'>자주 묻는 질문</div>
        <div className='rounded-xl'>
          {qnaList.map((item, i) => (
            <QnAItem key={i} q={item.q} a={item.a} askIcon={item.askIcon} answerIcon={item.answerIcon} />
          ))}
        </div>
      </div>
    </MobilePage>
  )
}

export default QnA
